//----------------------------------------------------------------------------------------------------------------------
// Null Logger Backend
//----------------------------------------------------------------------------------------------------------------------

import type { LoggingBackend } from '../../interfaces/logger.ts';

//----------------------------------------------------------------------------------------------------------------------

/**
 * A logging backend that does nothing (discards all logs).
 * Useful for production environments or when you want to completely disable logging.
 */
export class NullBackend implements LoggingBackend
{
    trace(_category : string, _message : string, ..._args : unknown[]) : void
    {
        // Do nothing
    }

    debug(_category : string, _message : string, ..._args : unknown[]) : void
    {
        // Do nothing
    }

    info(_category : string, _message : string, ..._args : unknown[]) : void
    {
        // Do nothing
    }

    warn(_category : string, _message : string, ..._args : unknown[]) : void
    {
        // Do nothing
    }

    error(_category : string, _message : string, ..._args : unknown[]) : void
    {
        // Do nothing
    }

    time(_category : string, _label : string) : void
    {
        // Do nothing
    }

    timeEnd(_category : string, _label : string) : void
    {
        // Do nothing
    }
}

//----------------------------------------------------------------------------------------------------------------------
